import { NavLink } from 'react-router-dom';
import { Home, Search, FileText, User, Inbox } from 'lucide-react';

import { cn } from '@/lib/utils';
import { selectIsAttached, useAuthStore } from '@/stores/useAuthStore';

const ATTACHED_ITEMS = [
  { to: '/dashboard', label: '대시보드', icon: Home },
  { to: '/my-requests', label: '내 가입 요청', icon: FileText },
  { to: '/profile', label: '프로필', icon: User },
];

const UNATTACHED_ITEMS = [
  { to: '/find-org', label: '조직 찾기', icon: Search },
  { to: '/my-requests', label: '내 가입 요청', icon: FileText },
  { to: '/profile', label: '프로필', icon: User },
];

// Phase 5c — org_admin 전용 추가 메뉴 (자기 조직 가입 요청 승인/거절)
const ORG_ADMIN_EXTRA = { to: '/approvals', label: '가입 요청 승인', icon: Inbox };

export function Sidebar() {
  const attached = useAuthStore(selectIsAttached);
  const user = useAuthStore((s) => s.user);
  const isOrgAdmin = user?.orgs.some((o) => o.role === 'org_admin') ?? false;
  const baseItems = attached ? ATTACHED_ITEMS : UNATTACHED_ITEMS;
  const items = isOrgAdmin ? [...baseItems, ORG_ADMIN_EXTRA] : baseItems;

  return (
    <aside className="hidden w-56 flex-col border-r bg-card md:flex">
      <div className="flex h-14 items-center px-4 text-lg font-semibold">ontoh 포털</div>
      <nav className="flex-1 px-2 py-2">
        {items.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-secondary text-foreground'
                  : 'text-muted-foreground hover:bg-accent hover:text-foreground',
              )
            }
          >
            <Icon className="size-4" />
            {label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
